import * as Yup from 'yup';

export const visitorValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome é obrigatório')
    .min(5, 'Nome deve ter no mínimo 5 caracteres'),
  
  document: Yup.string()
    .required('Documento é obrigatório')
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'Formato de CPF inválido'),
  
  phone_number: Yup.string()
    .required('Telefone é obrigatório')
    .matches(/^\(\d{2}\)\s\d{4,5}-\d{4}$/, 'Formato de telefone inválido'),
  
  tenant_id: Yup.string()
    .required('Empresa é obrigatória'),
  
  user_id: Yup.string()
    .required('Usuário responsável é obrigatório'),
  
  start_date: Yup.date()
    .required('Data de início é obrigatória')
    .min(new Date(), 'Data de início deve ser futura'),
  
  end_date: Yup.date()
    .required('Data de fim é obrigatória')
    .min(Yup.ref('start_date'), 'Data de fim deve ser posterior à data de início'),
  
  area_id: Yup.array()
    .min(1, 'Selecione pelo menos uma área')
    .required('Áreas são obrigatórias'),
});